
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import ConflictBeoordelingForm from "./ConflictBeoordelingForm";
import Section from "../../common/Section";
import redirector from "../../../util/redirector";
import ConflictBeoordelingPageHelper from "./ConflictBeoordelingPageHelper";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import cloneDeep from 'lodash/cloneDeep';

class ConflictBeoordelingPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            hasUnsavedChanges: false,
            disabled: false,
            model: null
        };

        this.pageHelper = new ConflictBeoordelingPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    componentWillUnmount() {
        this.state = {
            model: null
        };
    }
    componentDidUpdate = () => {
        super.componentDidUpdate();

        if (this.state.scrollToTop) {
            window.parent.scrollTo(0, 450);
            this.setState({
                scrollToTop: false
            });
        }
    };

    handleOnSetStyle = (feature, color) => this.pageHelper.setStyle(feature, color);

    beoordeelConflict = (isConflict) => this.pageHelper.beoordeelConflict(isConflict);

    closePage = () => this.pageHelper.closePage();

    render() {
        const props = this.props;
        const {
            osmBaseLayerUrl
        } = props;
        const disabled = props.disabled;
        const color = types.COLOR_BLUE;

        let model = this.state.model;

        if(model == null)
            return null;

        return (
            <Section
                title={`GPXconflict`}
                subtitle={`${model.gemeente} ${new Date(model.datumConflict).toLocaleDateString("nl-BE")}`}
                color={color}>
                <ConflictBeoordelingForm
                    disabled={disabled}
                    color={color}
                    osmBaseLayerUrl={osmBaseLayerUrl}
                    model={model}
                    customBounds={this.state.customBounds}
                    beoordeelConflict={this.beoordeelConflict}
                    closePage={this.closePage}
                />
            </Section>);
    }
}

ConflictBeoordelingPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state) {
    const disabled = state.settings.disabled;
    const shouldRedirect = !state.layout.topNavTabsSet;
    return {
        disabled: disabled,
        shouldRedirect: shouldRedirect,
        osmBaseLayerUrl: state.settings.osmBaseLayerUrl
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadDefaultLayout, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConflictBeoordelingPage);